export default {
  queue: {
    en: 'Shipping queue',
  },
  manage: {
    en: 'Manage',
  },
}
